import React, { Component } from "react";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import Header from "./header";
import { BASE_URL, getImages } from "./utility";

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      loading: true,
      error: null,
      previewImage: null,
    };
  }

  openPreview = (image) => {
    this.setState({ previewImage: image });
  };

  closePreview = () => {
    this.setState({ previewImage: null });
  };

  componentDidMount() {
    fetch(`${BASE_URL}filenames/${this.props.product}`, { method: "GET" })
      .then((response) => response.json())
      .then((responseJson) => {
        const raw = getImages(this.props.product, responseJson);

        // If images already include width/height, use them; otherwise measure.
        const needMeasuring = raw.some((r) => !r.width || !r.height);

        if (!needMeasuring) {
          // They already have width/height -> map directly
          const galleryImages = raw.map((img) => ({
            src: img.src,
            thumbnail: img.src,
            thumbnailWidth: img.width,
            thumbnailHeight: img.height,
            caption: this.props.desc || "Image",
          }));
          this.setState({ images: galleryImages, loading: false });
          return;
        }

        // Measure natural sizes for each image
        const measurePromises = raw.map(
          (img) =>
            new Promise((resolve) => {
              const image = new window.Image();
              image.onload = function () {
                const w = this.naturalWidth || 800;
                const h = this.naturalHeight || 600;
                resolve({
                  src: img.src,
                  thumbnail: img.src,
                  thumbnailWidth: w,
                  thumbnailHeight: h,
                  caption: img.caption || this.props?.desc || "Image",
                });
              }.bind(this);
              image.onerror = function () {
                // fallback ratio if load fails
                resolve({
                  src: img.src,
                  thumbnail: img.src,
                  thumbnailWidth: 4,
                  thumbnailHeight: 3,
                  caption: img.caption || this.props?.desc || "Image",
                });
              }.bind(this);
              // start loading (add cache-buster only if you suspect caching issues)
              image.src = img.src;
            })
        );

        Promise.all(measurePromises)
          .then((galleryImages) => {
            this.setState({ images: galleryImages, loading: false });
          })
          .catch((err) => {
            console.error("Error measuring images", err);
            // fallback: map without sizes
            const fallback = raw.map((img) => ({
              src: img.src,
              thumbnail: img.src,
              thumbnailWidth: 4,
              thumbnailHeight: 3,
              caption: this.props.desc || "Image",
            }));
            this.setState({ images: fallback, loading: false });
          });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ error: "Failed to load images", loading: false });
      });
  }

  render() {
    const { images, loading, error, previewImage } = this.state;

    return (
      <div  style={{ backgroundImage: `url(${BASE_URL + "download/general/bg"})` }}>

                <Header />
          <MenuBar />
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${BASE_URL}download/general/bg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          fontFamily: "'Poppins', sans-serif",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "2rem 1rem",
        }}
      >

    

        <h2
          style={{
            textAlign: "center",
            color: "#fff",
            margin: "1.5rem 0",
            fontSize: "1.8rem",
            fontWeight: "600",
          }}
        >
          {this.props.desc}
        </h2>

        {loading ? (
          <p style={{ color: "#ccc", fontSize: "1.1rem" }}>Loading images...</p>
        ) : error ? (
          <p style={{ color: "tomato", fontSize: "1.1rem" }}>{error}</p>
        ) : images.length > 0 ? (
          <div
            style={{
              width: "100%",
              maxWidth: "1100px",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              borderRadius: "12px",
              padding: "1.5rem",
              boxShadow: "0 4px 10px rgba(0,0,0,0.4)",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                gap: "12px",
              }}
            >
              {images.map((image, index) => (
                <button
                  key={`${image.src}-${index}`}
                  type="button"
                  onClick={() => this.openPreview(image)}
                  style={{
                    border: 0,
                    padding: 0,
                    background: "transparent",
                    cursor: "pointer",
                    aspectRatio: "4 / 3",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={image.thumbnail || image.src}
                    alt={image.caption}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </button>
              ))}
            </div>
          </div>
        ) : (
          <p style={{ color: "#aaa" }}>No images available.</p>
        )}

        {previewImage && (
          <div
            onClick={this.closePreview}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1050,
              backgroundColor: "rgba(0, 0, 0, 0.86)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px",
            }}
          >
            <button
              type="button"
              onClick={this.closePreview}
              aria-label="Close preview"
              style={{
                position: "fixed",
                top: "16px",
                right: "20px",
                border: "1px solid rgba(255,255,255,0.5)",
                backgroundColor: "rgba(0,0,0,0.4)",
                color: "white",
                fontSize: "28px",
                lineHeight: 1,
                width: "42px",
                height: "42px",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
            <img
              src={previewImage.src}
              alt={previewImage.caption}
              onClick={(event) => event.stopPropagation()}
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                objectFit: "contain",
                boxShadow: "0 12px 30px rgba(0,0,0,0.45)",
              }}
            />
          </div>
        )}

        <div style={{ marginTop: "2rem", width: "100%", textAlign: "center" }}>
          <SocialMediaLinks />
        </div>
      </div>
      </div>
    );
  }
}

export default Product;
